let statistic = require('../../actions/account/statistic');
let utils = require('../../actions/utils');
let error = require('../../actions/error');
let { usingLock } = require('../utils');

let getStatisticChunk = [
    statistic.addStartIndexesToArgs,
    [
        statistic.getStatisticChunk,
        {
            success: [ statistic.setRows ],
            error: [ error.internalError ],
            orderChanged: []
        }
    ]
];

module.exports = {
    getStatisticChunk,

    updateHeaderPosition: [
        utils.setFromArgsToState('topHeaderOffset', ['account', 'statistic', 'header', 'topOffset']),
        utils.setFromArgsToState('headerLeftOffsetLeft', ['account', 'statistic', 'header', 'left', 'offset', 'left'])
    ],

    expandHeader: [
        utils.toggleBool()
    ],

    toggleItem (path, value) {
        return [
            utils.toggleItem(path, value),
            ...getStatisticChunk
        ];
    },

    toggleTranspose: [
        utils.toggleBool(['account', 'statistic', 'isTransposed']),
        statistic.transpose,
        utils.queryRedirectFromState(['account', 'statistic', 'computed', 'query']),
        ...getStatisticChunk
    ],

    downloadExcel: [
        ...usingLock(['account', 'statistic', 'downloadExcelLock'], [
            [
                statistic.downloadExcel,
                {
                    success: [],
                    error: [ error.internalError ]
                }
            ]
        ])
    ],

    switchCityBranchMode: [
        utils.toggleBool(['account', 'statistic', 'isByBranch']),
        utils.queryRedirectFromState(['account', 'statistic', 'computed', 'query']),
        ...getStatisticChunk
    ]
};



// WEBPACK FOOTER //
// ./signals/account/statistic.js